<template>
  <div class="recommendList">
    <ul>
      <li v-for="(item,index) in recommendList" :key="index">
        <div class="num">
          <span :class="index <3 ? 'isSpan' : ''">
            {{index + 1}}
          </span>
        </div>
        <div class="li-one">
          <p class="p-name" @click="listClick(item.id)">{{item.name}}</p>
          <p class="p-author">{{item.author}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    recommendList: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
    }
  },
  methods: {
    listClick (id) {
      console.log(id + '222')
      this.$router.push({
        name: 'GoodsDetails',
        query: {
          id: id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .recommendList{
    ul{
      list-style: none;
      padding: 0;
      margin: 0;
      li{
        padding: 10px 10px 0 0;
        display: flex;
        p{
          padding: 0;
          margin: 0;
        }
        .num{
          width: 50px;
          text-align: center;
          font-size: 14px;
          padding-top: 2px;
          .isSpan{
            background-color: red;
            border-radius: 100%;
            width: 20px;
            line-height: 20px;
            color: white;
            display: inline-block;
          }
        }
        .li-one{
          overflow: hidden;
          flex: 1;
          img{
            width: 80px;
            cursor: pointer;
          }
          .p-name{
            padding-bottom: 10px;
            cursor: pointer;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
          }
          .p-name:hover{
            color: red;
          }
          .p-author{
            font-size: 14px;
          }
          .div-details{
            display: flex;
            .details-r{
              flex: 1;
              padding: 10px;
              font-size: 14px;
              .details-oldMoney{
                text-decoration: line-through
              }
              .details-oldMoney::before{
                content: '￥'
              }
              .details-nowMoney{
                color: red;
              }
              .details-oldMoney::before{
                content: '￥'
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/recommendList.vue


// WEBPACK FOOTER //
// src/components/Home/recommendList.vue